import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import "../../styles/features/Home/FullNews.css";
import img from "../../assets/images/parlament.jpg";
import { Carousel } from "antd";
//import {FullNews} from "./data"
import HomeNews from "./HomeNews";
import { getFullNews } from "./data";
import Spinner from "../../containers/Spinner";
import { getHomeNews } from "./data";
import { Typography } from "antd";

const { Title, Text } = Typography;

class FullNews extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.moveCarusel();
  }
  componentWillMount = () => {
    getFullNews(this.props.match.params.id).then(response => {
      console.log("response", response);
      this.setState({ news: response[0] });
    });
    getHomeNews().then(response => {
      this.setState({ lajmet: response });
    });
  };
  state = {};
  moveCarusel = () => {
    setTimeout(() => {
      if (this.myRef.current !== null) {
        this.slider.next();
        this.moveCarusel();
      }
    }, 3000);
  };

  render() {
    if (!this.state.news || !this.state.lajmet) {
      return <Spinner />;
    }
    let news = this.state.news;
    return (
      <div ref={this.myRef} className="full-news-container">
        <Typography>
          <Title>{news.Titulli}</Title>
        </Typography>
        <div className="full-news-carusel ">
          <img
            className="fullImage"
            src={
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmMjFNX4PiYAZivBXbaYrTgAUL1VI-Jry-2pKeUghZdjNVzyNLng"
            }
            alt=" "
          />
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: news.Permbajtja }}
          className="full-news-body"
        />
        <div className="full-news-carusel">
          <Carousel
            ref={slider => {
              this.slider = slider;
            }}
          >
            <img
              src={
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmMjFNX4PiYAZivBXbaYrTgAUL1VI-Jry-2pKeUghZdjNVzyNLng"
              }
              alt=""
            />
            <img
              src={
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmMjFNX4PiYAZivBXbaYrTgAUL1VI-Jry-2pKeUghZdjNVzyNLng"
              }
              alt=""
            />
            <img
              src={
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmMjFNX4PiYAZivBXbaYrTgAUL1VI-Jry-2pKeUghZdjNVzyNLng"
              }
              alt=""
            />
          </Carousel>
        </div>
        <div className="sidebarContent">
          <HomeNews data={this.state.lajmet} sidebar="true" />
        </div>
      </div>
    );
  }
}

export default FullNews;
